<div class="flex flex-col gap-6">
  <div class="flex items-start justify-between gap-4">
    <div class="flex flex-col">
      <h3 class="text-2xl">
        {{ 'pages.campaignForm.sections.creatorsAndCtas.deliverableFlow.platformStep.whatShouldBeTracked' | translate }}
      </h3>
      <p class="text-shikenso-purple-base-60">
        {{
          'pages.campaignForm.sections.creatorsAndCtas.deliverableFlow.platformStep.selectPlatformDescription'
            | translate
        }}
      </p>
    </div>

    @if (!ctaForm()?.controls?.deliverables?.value?.length) {
      <button
        mat-icon-button
        type="button"
        class="platform-step-template-trigger"
        [matMenuTriggerFor]="globalTemplateMenu"
      >
        <app-icon src="icons/template.svg" [size]="20" />
      </button>
    }

    <mat-menu #globalTemplateMenu="matMenu" class="platform-step-template-menu">
      <div class="platform-step-template-menu-content">
        <mat-form-field class="w-full platform-step-template-search custom-form">
          <input
            matInput
            [value]="templateSearchTerm()"
            [placeholder]="
              'pages.campaignForm.sections.creatorsAndCtas.deliverableFlow.platformStep.searchGlobalTemplate'
                | translate
            "
            (click)="$event.stopPropagation()"
            (input)="onTemplateSearchTermChange($event)"
          />
        </mat-form-field>

        @if (isGlobalTemplatesLoading()) {
          <div class="flex flex-col gap-2 px-2 pb-2">
            @for (i of [1, 2, 3]; track i) {
              <div class="flex items-center h-12 w-full">
                <ngx-skeleton-loader
                  class="h-6"
                  [theme]="{ width: '240px', height: '24px', 'border-radius': '100vw' }"
                />
              </div>
            }
          </div>
        } @else if (!filteredGlobalTemplates().length) {
          <div class="px-3 py-2 text-sm text-shikenso-gray-600">
            {{
              'pages.campaignForm.sections.creatorsAndCtas.deliverableFlow.platformStep.noGlobalTemplatesFound'
                | translate
            }}
          </div>
        } @else {
          @for (template of filteredGlobalTemplates(); track template.id) {
            <button mat-menu-item type="button" (click)="onGlobalTemplateSelected(template)">
              <div class="flex items-center gap-2">
                <app-social-badge
                  color="var(--shikenso-base-white)"
                  [type]="template.platformFeature"
                  [size]="24"
                  [iconSize]="12"
                  [borderRadius]="100"
                />
                <span
                  class="max-w-[200px] text-ellipsis line-clamp-1"
                  matTooltip
                  matTooltipPosition="right"
                  [appTextClampTooltip]="template.name"
                >
                  {{ template.name }}
                </span>
              </div>
            </button>
          }
        }
      </div>
    </mat-menu>
  </div>

  @if (deliverableConfigurations() === null || validPlatforms() === null) {
    <div class="grid grid-cols-4 gap-3">
      @for (i of [1, 2, 3, 4, 5, 6]; track i) {
        <ngx-skeleton-loader class="h-[92px]" [theme]="{ width: '100%', height: '92px', 'border-radius': '12px' }" />
      }
    </div>
  } @else if (!availableCtaOptions().length) {
    <div class="platform-step-empty-state">
      {{ 'pages.campaignForm.sections.creatorsAndCtas.deliverableFlow.platformStep.noCommonPlatforms' | translate }}
    </div>
  } @else {
    <div class="grid grid-cols-4 gap-3">
      @for (ctaOption of availableCtaOptions(); track ctaOption.id) {
        <button
          type="button"
          class="platform-step-card"
          [class.platform-step-card-selected]="platformFeatureForm.controls.platformFeature.value?.id === ctaOption.id"
          (click)="onPlatformSelected(ctaOption)"
        >
          <app-social-badge
            color="var(--shikenso-base-white)"
            [type]="ctaOption.platformFeature"
            [size]="32"
            [iconSize]="16"
            [borderRadius]="8"
          />
          <span class="text-sm">
            {{ 'shared.platformFeatures.' + ctaOption.platformFeature | translate }}
          </span>
        </button>
      }
    </div>
  }

  @if (getPlatformFeatureWarnings().length) {
    <div class="flex flex-col gap-1">
      @for (warningKey of getPlatformFeatureWarnings(); track warningKey) {
        <div class="flex items-center gap-1 text-xs text-shikenso-warning-base">
          <app-icon src="icons/warning.svg" color="var(--shikenso-warning-base)" [size]="14" />
          <span>{{ warningKey | translate }}</span>
        </div>
      }
    </div>
  }

  @if (
    deliverableConfigurations() !== null &&
    validPlatforms() !== null &&
    selectedCreatorIds().size === 1 &&
    !selectedCreatorIds().has(ALL_CREATORS_ID)
  ) {
    <div class="pt-10 flex flex-col gap-2">
      @let creatorName = selectedCreators()[0]!.name;

      <h3 class="text-base">
        {{
          'pages.campaignForm.sections.creatorsAndCtas.deliverableFlow.platformStep.youCanAlsoAddPlatform'
            | translate: { creatorName }
        }}
      </h3>
      <app-add-platform-input
        [placeholder]="
          'pages.campaignForm.sections.creatorsAndCtas.deliverableFlow.platformStep.urlToProfile'
            | translate: { creatorName }
        "
        [creatorId]="selectedCreators()[0].id!"
        [createChannelIndividually]="true"
        (createdChannel)="onCreatedChannel($event)"
      />
    </div>
  }
</div>
